import { CartAPIFullData, CartGlobalPriceType, CartMetaData } from '../club/types/oneCartAPI';

const defaultCartPrice: CartGlobalPriceType = {
    value: 0,
    currency: '',
};
export const defaultCartValue: CartAPIFullData['data'] = {
    cart: {
        itemList: [],
        summary: {
            quantity: 0,
            shipping: {
                totalAmount: defaultCartPrice,
                standardShipping: defaultCartPrice,
                twoManHandling: [],
            },
            itemsSubTotal: defaultCartPrice,
            costOfPayment: defaultCartPrice,
            grandTotal: defaultCartPrice,
            voucher: null,
            isCartMerged: false,
        },
    },
};

export const defaultCartMetadataValue: CartMetaData['data'] = {
    count: 0,
    expiry: '',
    expiryTimestamp: 0,
};
